/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type MarkerUpdateInput = {
    id: string;
    name?: string | null;
    description?: string | null;
    scrollPosition?: number | null;
    isFastTravel: boolean;
};
export type TourEditMarkerEditDialogUpdateMarkerMutationVariables = {
    input: MarkerUpdateInput;
};
export type TourEditMarkerEditDialogUpdateMarkerMutationResponse = {
    readonly markerUpdate: {
        readonly marker: {
            readonly id: string;
            readonly name: string;
            readonly description: string;
        };
    };
};
export type TourEditMarkerEditDialogUpdateMarkerMutation = {
    readonly response: TourEditMarkerEditDialogUpdateMarkerMutationResponse;
    readonly variables: TourEditMarkerEditDialogUpdateMarkerMutationVariables;
};



/*
mutation TourEditMarkerEditDialogUpdateMarkerMutation(
  $input: MarkerUpdateInput!
) {
  markerUpdate(input: $input) {
    marker {
      id
      name
      description
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkerUpdatePayload",
    "kind": "LinkedField",
    "name": "markerUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Marker",
        "kind": "LinkedField",
        "name": "marker",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourEditMarkerEditDialogUpdateMarkerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourEditMarkerEditDialogUpdateMarkerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1d28b0ad9b041f2c163e38e5919518fa",
    "id": null,
    "metadata": {},
    "name": "TourEditMarkerEditDialogUpdateMarkerMutation",
    "operationKind": "mutation",
    "text": "mutation TourEditMarkerEditDialogUpdateMarkerMutation(\n  $input: MarkerUpdateInput!\n) {\n  markerUpdate(input: $input) {\n    marker {\n      id\n      name\n      description\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0f6ca02c08e69af607bf95f2bbb96d40';
export default node;
